// Blog.jsx
import React from 'react';
import './Blog.css';
import backgroundImg from './assets/hero.jpg'; // make sure the path is correct

const Blog = () => {
  return (
    <div
      className="blog-page"
      style={{
        backgroundImage: `url(${backgroundImg})`,
      }}
    >
      <div className="blog-overlay">
        <div className="blog-content">
          <h2>Visit Our Blog</h2>
          <p>
            For the latest health tips and updates, check out our official blog.
          </p>
          <a
            href="https://mwangazawellness.blogspot.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="blog-button"
          >
            Go to Blog
          </a>
        </div>
      </div>
    </div>
  );
};

export default Blog;
